const makeModelColors = { GTT: 'green', Miovision: 'orange', 764: 'geekblue' };
const makeModelColorPicker = (entry) => {
  if (entry in makeModelColors) return makeModelColors[entry];
  return 'lightgrey';
};

export default makeModelColorPicker;
